import { __decorate } from "tslib";
import { Directive, Input, Output, EventEmitter } from "@angular/core";
import { rotate } from "../models/sort.model";
let CommonTableSortHeaderDirective = class CommonTableSortHeaderDirective {
    sortable = "";
    direction = "";
    sort = new EventEmitter();
    constructor() {
    }
    rotate() {
        this.direction = rotate[this.direction];
        this.sort.emit({ column: this.sortable, direction: this.direction });
    }
    static ctorParameters = () => [];
    static propDecorators = {
        sortable: [{ type: Input }],
        direction: [{ type: Input }],
        sort: [{ type: Output }]
    };
};
CommonTableSortHeaderDirective = __decorate([
    Directive({
        // tslint:disable-next-line:directive-selector
        selector: "th[sortable]",
        // tslint:disable-next-line:no-host-metadata-property
        host: {
            "[class.asc]": "direction === \"asc\"",
            "[class.desc]": "direction === \"desc\"",
            "(click)": "rotate()"
        }
    })
], CommonTableSortHeaderDirective);
export { CommonTableSortHeaderDirective };
